// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect, useState } from 'react';
import { useContextSelector } from 'use-context-selector';
import download from 'downloadjs';

import ModalManager from 'Containers/ModalManager/ModalManager';
import AlertsModalComponent from 'Components/Alerts/AlertsModal';
import useModals from 'Hooks/useModals';
import useNotifications from 'Hooks/useNotifications';
import { UIContext } from 'Contexts/UIContext';
import { UserContext } from 'Contexts/UserContext';

const AlertsModal = memo(() => {
  const modalsCtx = useModals();
  const notificationsCtx = useNotifications();
  const [loading, setLoading] = useState(false);
  const [alreadyOpened, setAlreadyOpened] = useState(false);
  const { uiState, setUiState } = useContextSelector(UIContext, data => data);
  const user = useContextSelector(UserContext, data => data.data);

  useEffect(() => {
    if (notificationsCtx.data.length) {
      if (!alreadyOpened) {
        setAlreadyOpened(true);
        setUiState({ alertsModalOpened: true });
      }
      if (!uiState.alertsModalOpened) {
        modalsCtx.openModal(modalsCtx.modalState.NOTIFICATIONS.key);
      }
      modalsCtx.setState(modalsCtx.modalState.NOTIFICATIONS.key, {
        notifications: notificationsCtx.data || []
      });
    } else if (alreadyOpened) {
      modalsCtx.setState(modalsCtx.modalState.NOTIFICATIONS.key, {
        open: false,
        notifications: []
      });
    }
  }, [notificationsCtx.data, alreadyOpened]);

  useEffect(() => {
    if (!user.loggedIn) {
      setUiState({ alertsModalOpened: false });
      modalsCtx.resetModal();
    }
  }, [user.loggedIn]);

  const handleOnMarkAsRead = async id => {
    try {
      setLoading(id);
      await notificationsCtx.onMarkAsRead(id);
    } finally {
      setLoading(false);
    }
  };

  const handleOnClose = () => {
    modalsCtx.closeModal(modalsCtx.modalState.NOTIFICATIONS.key);
  };

  const handleFileDownload = async fileId => {
    const response = await fetch(`/messages/${fileId}/download`);
    const file = await response.blob();
    const blob = new Blob([file], { type: response.headers.get('content-type') });
    if (typeof document !== 'undefined') {
      const fileName = response.headers.get('content-disposition').match(/filename="(.*)"/);
      download(blob, fileName[1]);
    }
  };

  return (
    <ModalManager open={ modalsCtx.modalState.NOTIFICATIONS.state.open }>
      <AlertsModalComponent
        onClose={ handleOnClose }
        open={ modalsCtx.modalState.NOTIFICATIONS.state.open }
        loadingNotifications={ notificationsCtx.loading }
        notifications={ modalsCtx.modalState.NOTIFICATIONS.state?.notifications || [] }
        onRead={ handleOnMarkAsRead }
        loading={ loading }
        handleFileDownload={ handleFileDownload }
      />
    </ModalManager>
  );
});

AlertsModal.displayName = 'AlertsModalContainer';

export default AlertsModal;
